if (!customElements.get('glow-mini-bundle')) {
  customElements.define('glow-mini-bundle', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.scope = document.getElementById('shopify-section-' + this.dataset.section);
      this.addEventListener('change', () => {
        this.querySelector('.gm-second').hidden = this.querySelector('input:checked').value !== '2';
      }, { signal });
      this.addEventListener('click', event => {
        const option = event.target.closest('[data-gm-variant]');
        if (!option || option.disabled) return;
        const picker = option.closest('.gm-picker');
        picker.parentElement.querySelector('input[type="hidden"]').value = option.dataset.gmVariant;
        const summary = picker.querySelector('summary');
        summary.querySelector('img').src = option.querySelector('img').src;
        summary.querySelector('span').textContent = option.querySelector('span').textContent;
        picker.querySelectorAll('[data-gm-variant]').forEach(item => item.setAttribute('aria-pressed', String(item === option)));
        picker.open = false;
        summary.focus();
      }, { signal });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          const picker = event.target.closest('.gm-picker');
          if (picker) { picker.open = false; picker.querySelector('summary').focus(); }
        }
      }, { signal });
      this.scope?.addEventListener('submit', event => {
        if (event.target.getAttribute('id') !== 'product-form-' + this.dataset.section) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.addItems(event.target);
      }, { capture: true, signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
    async addItems(form) {
      if (this.busy) return;
      const error = this.querySelector('.gm-error');
      error.hidden = true;
      const variantId = Number(this.querySelector('.gm-first-select')?.value || new FormData(form).get('id'));
      const secondId = Number(this.querySelector('.gm-second-select, .gm-second select').value);
      const quantity = Number(this.querySelector('input:checked').value);
      if (!variantId || (quantity === 2 && !secondId)) {
        error.textContent = this.dataset.error;
        error.hidden = false;
        return;
      }
      const items = [{ id: variantId, quantity: quantity === 2 && variantId === secondId ? 2 : 1 }];
      if (quantity === 2 && variantId !== secondId) items.push({ id: secondId, quantity: 1 });
      this.busy = true;
      const button = form.querySelector('[type="submit"]');
      if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
        window.location.assign(this.dataset.cartUrl);
      } catch (problem) {
        error.textContent = problem.message || this.dataset.error;
        error.hidden = false;
      } finally {
        this.busy = false;
        if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
      }
    }
  });
}
